module.exports = __webpack_public_path__ + "static/media/zolePlayed_250_500.aa6f546a.png";